export default __webpack_public_path__ + "static/media/check-bold-white-icon.5ab2a81d.svg";